<template>
  <div class="modal fade modal-load-check" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          Weighbridge Details for {{ loadDecorated.reference_number }}
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-7">
              <div class="row">
                <div class="col-sm-6">
                  <p class="material-details">
                    <strong>Date</strong><br />
                    {{ weighbridgeDecorated.date }}
                  </p>
                </div>
                <div class="col-sm-6">
                  <p class="material-details">
                    <strong>Status</strong><br />
                    <span :class="weighbridgeDecorated.status_class">{{ weighbridgeDecorated.status_text }}</span>
                  </p>
                </div>
                <div class="col-sm-6">
                  <p class="material-details">
                    <strong>Vehicle Rego</strong><br />
                    {{ loadDecorated.registration }}
                  </p>
                </div>
                <div v-if="!$user.isClient" class="col-sm-6">
                  <p class="material-details">
                    <strong>Configuration</strong><br />
                    {{ loadDecorated.configuration_description }}
                  </p>
                </div>
                <div v-if="!$user.isClient" class="col-sm-6">
                  <p class="material-details truncate">
                    <strong>From</strong><br />
                    {{ loadDecorated.location_from &&loadDecorated.location_from.formatted_name }}
                  </p>
                </div>
                <div v-if="!$user.isClient" class="col-sm-6">
                  <p class="material-details truncate">
                    <strong>To</strong><br />
                    {{ loadDecorated.location_to && loadDecorated.location_to.formatted_name }}
                  </p>
                </div>
                <div class="col-sm-6">
                  <p class="material-details">
                    <strong>Total Net Delivered</strong><br />
                    {{ weighbridgeDecorated.total_tonnage }}t
                  </p>
                </div>
                <div v-if="!$user.isClient" class="col-sm-6">
                  <p class="material-details">
                    <strong>Commodity</strong><br />
                    {{ loadDecorated.commodityName }}
                  </p>
                </div>
                <div class="col-sm-6">
                  <p class="material-details">
                    <strong>Pickup Reference</strong><br />
                    {{ jobDecorated.pickup_reference }}
                  </p>
                </div>
                <div class="col-sm-6">
                  <p class="material-details">
                    <strong>Delivery Reference</strong><br />
                    {{ jobDecorated.delivery_reference }}
                  </p>
                </div>
                <div class="col-sm-6">
                  <p class="material-details">
                    <strong>Order</strong><br />
                    {{ jobDecorated.order_reference }}
                  </p>
                </div>
                <div class="col-sm-6">
                  <p class="material-details">
                    <strong>Driver Notes</strong><br />
                    {{ load.notes }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div v-show="tabName === 'delivery'" class="col-sm-6">
                  <p class="material-details">
                    <strong>Delivery Date</strong><br />
                    <date-range
                      v-model="deliveryDate"
                      :single-date-picker="true"
                      opens="right"
                      drops="up"
                      placeholder="00/00/0000"
                      name="delivery_date">
                    </date-range>
                  </p>
                </div>
                <div v-show="tabName === 'delivery'" class="col-sm-6">
                  <p class="material-details">
                    <strong>Delivery Time</strong><br />
                    <flat-pickr class="form-control" v-model="deliveryTime" :config="flatPickerConfig"  placeholder="9:00 AM">
                    </flat-pickr>
                  </p>
                </div>
                <div v-show="tabName === 'pickup'" class="col-sm-6">
                  <p class="material-details">
                    <strong>Loading Date</strong><br />
                    <date-range
                      v-model="loadingDate"
                      :single-date-picker="true"
                      opens="right"
                      drops="up"
                      placeholder="00/00/0000"
                      name="loading_date">
                    </date-range>
                  </p>
                </div>
                <div v-show="tabName === 'pickup'" class="col-sm-6">
                  <p class="material-details">
                    <strong>Loading Time</strong><br />
                    <flat-pickr class="form-control" v-model="loadingTime" :config="flatPickerConfig"  placeholder="9:00 AM">
                    </flat-pickr>
                  </p>
                </div>
              </div>

              <ul class="nav nav-tabs m-t-md">
                <li :class="{ 'active': commodityTypeIsDelivery }">
                  <a href="#delivery" data-toggle="tab" @click="tabName = 'delivery'">Delivery ({{ deliveryDockets.length }})</a>
                </li>
                <li :class="{ 'active': commodityTypeIsPickup }">
                  <a href="#pickup" data-toggle="tab" @click="tabName = 'pickup'">Pickup ({{ pickupDockets.length }})</a>
                </li>
                <li>
                  <a href="#connote" data-toggle="tab" @click="tabName = 'connote'">Con-note ({{ conNotes.length }})</a>
                </li>
              </ul>

              <div class="tab-content">
                <div class="tab-pane" :class="{ 'active': commodityTypeIsDelivery }" id="delivery">
                  <ul class="load-dockets">
                    <load-check-modal-item v-for="docket in deliveryDockets" :key="docket.id" :docket="docket"></load-check-modal-item>

                    <li class="text-center text-muted" v-show="!deliveryDockets.length">
                      No delivery dockets.
                    </li>
                  </ul>
                </div>
                <div class="tab-pane" :class="{ 'active': commodityTypeIsPickup }" id="pickup">
                  <ul class="load-dockets">
                    <load-check-modal-item v-for="docket in pickupDockets" :key="docket.id" :docket="docket"></load-check-modal-item>

                    <li class="text-center text-muted" v-show="!pickupDockets.length">
                      No pickup dockets.
                    </li>
                  </ul>
                </div>
                <div class="tab-pane" id="connote">
                  <ul class="load-dockets">
                    <load-check-modal-item
                      v-for="docket in conNotes" :key="docket.id" :docket="docket"
                      v-on:update-delivery-time="updateDeliveryTime"
                    ></load-check-modal-item>

                    <li class="text-center text-muted" v-show="!conNotes.length">
                      No consignment notes.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <load-check-modal-preview></load-check-modal-preview>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
          <button v-if="haveNextLoad" @click="goToNextLoad" class="btn btn-sm btn-default">Next Load</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState, mapActions } from 'vuex'
  import { DateRange } from 'components/forms'
  import { LoadDecorator, WeighbridgeDecorator, JobDecorator } from 'decorators'
  import { SET_WEIGHBRIDGE, SET_LOAD, SET_DOCKET, RESET_DOCKET, SET_JOB, SET_LOAD_ATTRIBUTE, ADD_LOAD } from 'vx/mutations'
  import { filter, findIndex, findLastIndex, find, camelCase } from 'lodash'
  import LoadCheckModalItem from './LoadCheckModalItem'
  import LoadCheckModalPreview from './LoadCheckModalPreview'
  import $ from 'jquery'
  import flatPickr from 'vue-flatpickr-component'
  import moment from 'moment'

  export default {
    components: {
      DateRange,
      flatPickr,
      LoadCheckModalItem,
      LoadCheckModalPreview
    },

    mounted () {
      this.loadAndDelivery.forEach(prop => {
        const key = camelCase(prop)
        this[key] = this.load[prop]
        this.$watch(key, val => {
          if (val !== this.load[prop]) {
            this.updateLoad({ id: this.load.id, payload: { [prop]: val } }).then(() => {
              this[SET_LOAD_ATTRIBUTE](prop, this[key])
            }).then(() => {
              // update load on the jobs page
              this[ADD_LOAD](this.load)
            })
          }
        })
      })

      $(this.$el).on('shown.bs.modal', function () {
        $(document).off('focusin.modal')
      })
    },

    data () {
      return {
        tabName: this.commodityType && this.commodityType !== '-' ? this.commodityType : 'delivery',
        loadAndDelivery: [
          'loading_date',
          'loading_time',
          'delivery_date',
          'delivery_time'
        ],
        flatPickerConfig: {
          altFormat: 'h:i K',
          altInput: true,
          enableTime: true,
          noCalendar: true,
          dateFormat: 'h:i K',
          minuteIncrement: 1
        },
        loadingDate: null,
        loadingTime: null,
        deliveryDate: null,
        deliveryTime: null
      }
    },

    created () {
      this.updateState()
    },

    watch: {
      load (load) {
        this.updateState()

        this.loadingDate = load.loading_date
        this.loadingTime = load.loading_time
        this.deliveryDate = load.delivery_date
        this.deliveryTime = load.delivery_time
      }
    },

    computed: {
      ...mapState('weighbridge', ['weighbridge']),
      ...mapState('weighbridge/docket', ['docket']),
      ...mapState('load', ['load']),
      ...mapState('job', ['job']),
      ...mapState('loadCheck', ['loads']),

      /**
       * Delivery dockets for the weighbridge.
       *
       * @return array
       */
      deliveryDockets () {
        return filter(this.weighbridge.dockets, docket => docket.type === 'delivery')
      },

      /**
       * Pickup dockets for the weighbridge.
       *
       * @return array
       */
      pickupDockets () {
        return filter(this.weighbridge.dockets, docket => docket.type === 'pickup')
      },

      conNotes () {
        return filter(this.weighbridge.dockets, docket => docket.type === 'connote')
      },

      /**
       * The commodity charge type.
       *
       * @return string
       */
      commodityType () {
        return this.load.commodity
          ? this.load.commodity.charge_type
          : '-'
      },

      /**
       * Determine if commodity charge type is delivery.
       *
       * @return boolean
       */
      commodityTypeIsDelivery () {
        return this.commodityType === 'delivery'
      },

      /**
       * Determine if commodity charge type is pickup.
       *
       * @return boolean
       */
      commodityTypeIsPickup () {
        return this.commodityType === 'pickup'
      },

      /**
       * Decorated load.
       *
       * @return object
       */
      loadDecorated () {
        return new LoadDecorator(this.load)
      },

      /**
       * Decorated job.
       *
       * @return object
       */
      jobDecorated () {
        return new JobDecorator(this.job)
      },

      /**
       * Decorated weighbridge.
       *
       * @return object
       */
      weighbridgeDecorated () {
        return new WeighbridgeDecorator(this.weighbridge)
      },

      /**
       * Determine if we have a next load.
       *
       * @return boolean
       */
      haveNextLoad () {
        return filter(this.loads, (load) => (load.weighbridge !== null && load.weighbridge.dockets.length > 0)).length > 1
      },

      deliveryDateAsMoment () {
        if (this.loadDecorated && this.loadDecorated.delivery_date) {
          return moment(this.loadDecorated.delivery_date, 'DD/MM/YYYY')
        }

        return null
      }
    },

    methods: {
      ...mapMutations('weighbridge', [SET_WEIGHBRIDGE]),
      ...mapMutations('weighbridge/docket', [SET_DOCKET, RESET_DOCKET]),
      ...mapMutations('load', [SET_LOAD, SET_LOAD_ATTRIBUTE, ADD_LOAD]),
      ...mapMutations('job', [SET_JOB]),
      ...mapActions('load', ['updateLoad']),

      updateDeliveryTime ({ deliveryDate, deliveryTime }) {
        this.deliveryDate = deliveryDate
        this.deliveryTime = deliveryTime
      },

      /**
       * Update the state.
       *
       * @return void
       */
      updateState () {
        this[SET_WEIGHBRIDGE](this.load.weighbridge)

        // If we already have a selected docket and it exists on the weighbridges
        // dockets then we won't reset as this looks a little strange when
        // approving/rejecting dockets.
        if (this.docket.id && find(this.load.weighbridge.dockets, docket => docket.id === this.docket.id) !== undefined) {
          return
        }

        this[RESET_DOCKET]()

        let firstDocketOfType = find(this.load.weighbridge.dockets, docket => {
          return docket.type === this.commodityType
        })

        if (firstDocketOfType) {
          this[SET_DOCKET](firstDocketOfType)
        }
      },

      /**
       * Go to the next load.
       *
       * @return void
       */
      goToNextLoad () {
        let existingIndex = findIndex(this.loads, existing => existing.id === this.load.id)
        let lastIndex = findLastIndex(this.loads)
        let nextIndex = findIndex(this.loads, (existing, index) => {
          const hasWeighbridge = (load) => {
            return load.weighbridge !== null && load.weighbridge.dockets.length > 0
          }

          if (existingIndex === lastIndex) {
            return hasWeighbridge(existing)
          } else if (index > existingIndex) {
            return hasWeighbridge(existing)
          }

          return false
        })

        this[SET_LOAD](this.loads[nextIndex])

        if (this.loads[nextIndex].job) {
          this[SET_JOB](this.loads[nextIndex].job)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoadCheckModal.vue?264831de